import { render, staticRenderFns } from "./ThgBatchDetailView.vue?vue&type=template&id=1e6a9dc2&"
import script from "./ThgBatchDetailView.vue?vue&type=script&lang=ts&"
export * from "./ThgBatchDetailView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports